import React from 'react';
import Blanket from '@atlaskit/blanket';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { ChangeOwnerDashboardModule as ChangeDashboardModalType, Props } from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const NoLazyAsyncChangeOwnerDashboardModal = lazy<typeof ChangeDashboardModalType>(
	() => import(/* webpackChunkName: "async-change-owner-modal" */ './index'),
);

const AsyncChangeOwnerDashboardModal = (props: Props): React.JSX.Element => (
	<JSErrorBoundary
		id="configure-owner-modal"
		packageName="dashboard"
		fallback="flag"
		teamName="endeavour"
	>
		<Placeholder name="change-owner-modal" fallback={<Blanket />}>
			<NoLazyAsyncChangeOwnerDashboardModal {...props} />
		</Placeholder>
	</JSErrorBoundary>
);

export default AsyncChangeOwnerDashboardModal;
